'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

EventsService.$inject = ['EventsConstants', 'ApiService', '$window', '$log', '$filter'];


var _module = _angular2.default.module('cb.events.service', []);

_module.service('EventsService', EventsService);

exports.default = _module;

/**
 * @ngdoc service
 * @name EventsService
 *
 * @description This service is used to trigger events, which are picked up by Relay42 for analytics purposes.
 *
 * @example
 * To trigger a pageview: `cb('analytics', 'triggerPageView', 'page-name-here');`
 * To trigger a pageview from inside (Angular) front-end code: `EventsService.triggerPageView('page-name-here');`
 */

function EventsService(EventsConstants, ApiService, $window, $log, $filter) {
    var service = {
        init: init,
        triggerPageView: triggerPageView,
        triggerResult: triggerResult,
        triggerWarning: triggerWarning,
        triggerError: triggerError,
        triggerUserError: triggerUserError,
        triggerUserWarning: triggerUserWarning,
        triggerServiceError: triggerServiceError,
        triggerServiceWarning: triggerServiceWarning
    };

    return service;

    function init() {
        ApiService.attach({
            analytics: {
                triggerPageView: triggerPageView,
                triggerResult: triggerResult,
                triggerWarning: triggerWarning,
                triggerError: triggerError,
                triggerUserError: triggerUserError,
                triggerUserWarning: triggerUserWarning,
                triggerServiceError: triggerServiceError,
                triggerServiceWarning: triggerServiceWarning
            }
        });
    }

    function polyfillElementClosest() {
        if (window.Element && !Element.prototype.closest) {
            Element.prototype.closest = function (s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i,
                    el = this;
                do {
                    i = matches.length;
                    while (--i >= 0 && matches.item(i) !== el) {};
                } while (i < 0 && (el = el.parentElement));
                return el;
            };
        }
    }

    function triggerPageView(name) {
        if ($window._st && $window._st.settings) {
            var pageStructure = _angular2.default.copy($window._st.settings.defaultPageStructure);
            pageStructure = pageStructure.concat(name.split('/').filter(Boolean));

            $window._st('resetTags');
            $window._st('setPageStructure', pageStructure.join('|'));
            $window._st('loadTags');
        } else {
            $log.log('triggerPageView: ' + ['name:', name].join(' '));
        }
    }

    function triggerResult(eventName, data) {
        if ($window._st && $window._st.event) {
            $window._st.event.publish(EventsConstants.EVENT_RESULT, eventName, data);
        } else {
            $log.log('triggerResult: ' + ['category:', EventsConstants.EVENT_RESULT, 'eventName:', eventName, 'data:', $filter('json')(data)].join(' '));
        }
    }

    function triggerUserError(key, control, element) {
        polyfillElementClosest();

        var isPrivate = element.closest('[cb-private]').length > 0 || element.closest('[data-cb-private]').length > 0;
        var message = element.find('[ng-message], [data-ng-message]').text().trim();
        var value = !isPrivate ? control.$viewValue : '(private)';

        if ($window._st && $window._st.event) {
            $window._st.event.publish(EventsConstants.EVENT_USER_ERROR, 'input-fields', {
                field: key,
                value: value,
                errorMsg: message
            });
        } else {
            $log.log('triggerUserError: ' + ['field:', key, 'value:', value, 'errorMsg:', message].join(' '));
        }
    }

    function triggerUserWarning(text) {
        if ($window._st && $window._st.event) {
            $window._st.event.publish(EventsConstants.EVENT_USER_WARNING, 'input-fields', text);
        } else {
            $log.log('triggerUserWarning: ' + text);
        }
    }

    function triggerWarning(text) {
        if ($window._st && $window._st.event) {
            $window._st.event.publish(EventsConstants.EVENT_WARNING, 'front-end', text);
        } else {
            $log.log('triggerWarning: ' + text);
        }
    }

    function triggerError(text) {
        if ($window._st && $window._st.event) {
            $window._st.event.publish(EventsConstants.EVENT_ERROR, 'front-end', text);
        } else {
            $log.log('triggerError: ' + text);
        }
    }

    function triggerServiceWarning(service, text) {
        if ($window._st && $window._st.event) {
            $window._st.event.publish(EventsConstants.EVENT_SERVICE_WARNING, 'service', text);
        } else {
            $log.log('triggerServiceWarning: ' + text);
        }
    }

    function triggerServiceError(service, text) {
        if ($window._st && $window._st.event) {
            $window._st.event.publish(EventsConstants.EVENT_SERVICE_ERROR, 'service', text);
        } else {
            $log.log('triggerServiceError: ' + text);
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/events/events.service.js
// module id = 773
// module chunks = 0